import { render, staticRenderFns } from "./article-class.vue?vue&type=template&id=0d1adebc&"
import script from "./article-class.vue?vue&type=script&lang=js&"
export * from "./article-class.vue?vue&type=script&lang=js&"
import style0 from "./article-class.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports